var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.929,
    height: 22.484,
    viewBox: "0 0 22.929 22.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedIn",
    transform: "translate(-1567 -6492.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M17.735-1894.515a.8.8,0,0,1-.566-.234.793.793,0,0,1-.233-.565v-6.043a1.4,1.4,0,0,0-1.4-1.4,1.4,1.4,0,0,0-1.4,1.4v6.043a.8.8,0,0,1-.8.8h-4.4a.794.794,0,0,1-.565-.234.793.793,0,0,1-.234-.565V-1908.5a.8.8,0,0,1,.8-.8h4.4a.8.8,0,0,1,.8.8v.089a5.7,5.7,0,0,1,3.047-.889,5.76,5.76,0,0,1,5.745,5.744v8.242a.8.8,0,0,1-.8.8Zm.8-6.843v5.244h2.8v-7.442a4.1,4.1,0,0,0-1.57-3.259,4.086,4.086,0,0,0-2.553-.887,4.106,4.106,0,0,0-3.243,1.571.787.787,0,0,1-.623.3.784.784,0,0,1-.269-.047.8.8,0,0,1-.533-.753v-1.072h-2.8v11.588h2.8v-5.244a3,3,0,0,1,3-3A3,3,0,0,1,18.534-1901.358Zm-17.283,6.843a.8.8,0,0,1-.8-.8V-1908.5a.8.8,0,0,1,.8-.8h4.4a.8.8,0,0,1,.8.8v13.186a.8.8,0,0,1-.8.8Zm.8-1.6h2.8V-1907.7h-2.8ZM3.425-1910.5H3.41c-.061,0-.122,0-.182,0H3.2a3.207,3.207,0,0,1-2.274-.965A3.209,3.209,0,0,1,0-1913.747c0-.071,0-.144.008-.215A3.268,3.268,0,0,1,3.257-1917c.069,0,.139,0,.209.007a3.37,3.37,0,0,1,.4,0,3.235,3.235,0,0,1,2.229,1.111,3.234,3.234,0,0,1,.79,2.363,3.264,3.264,0,0,1-3.244,3.028C3.574-1910.489,3.5-1910.491,3.425-1910.5Zm.036-1.6a1.7,1.7,0,0,0,.331,0,1.648,1.648,0,0,0,1.123-.591,1.646,1.646,0,0,0,.376-1.213,1.65,1.65,0,0,0-1.65-1.507,1.443,1.443,0,0,0-.154.007l-.025,0-.025,0a1.693,1.693,0,0,0-.309,0,1.646,1.646,0,0,0-1.131.573,1.648,1.648,0,0,0-.394,1.206,1.664,1.664,0,0,0,1.651,1.531c.043,0,.086,0,.13,0h.064Z",
    transform: "translate(1567 8409.987)",
    fill: "#0072b1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.c1e5f6e264a94b8c2841864b58151667.svg";
export { ForwardRef as ReactComponent };